import React from 'react';
import Header from '../landing_page/header';
import Footer from '../landing_page/footer';
import './Pillow.css';
import { AiOutlinePicture, AiFillPhone } from "react-icons/ai";
import PillowiseLogo from '../images/pillowise/pillowise-logo.svg';
import CustomFitSizes from '../images/pillowise/sizes.png';
import MeasurementProcess from '../images/pillowise/mesurements_process.png';
import PillowInUse from '../images/pillowise/pillow_in_use.png';

const GALLERY_IMAGES = [
  { label: 'Custom Fit Sizes', src: CustomFitSizes },
  { label: 'Measurement Process', src: MeasurementProcess },
  { label: 'Pillow in Use', src: PillowInUse },
];

const STEPS = [
  { title: '3 Simple Measurements', text: 'We measure your shoulders, neck, and preferred sleep position.' },
  { title: 'Your Perfect Match', text: 'The Pillowise algorithm matches those measurements to your ideal pillow size.' },
  { title: 'Better Sleep, Less Pain', text: 'Your cervical spine stays aligned all night, easing pressure on your neck and joints.' },
];

const BENEFITS = [
  'Personalized to your exact measurements, not one-size-fits-all',
  'Aligns your cervical spine for proper neck and joint support',
  'Relieves pressure that leads to morning stiffness and tension',
  'Backed by an algorithm developed with a physiotherapist since 2003',
  'Recommended by over 5,000 healthcare professionals worldwide',
];

export default function Pillow() {
  return (
    <div>
      <Header />
      <div className='pillow-container'>
        <div className="large-monitor pillow" data-aos="fade-in">

          <div className='pillow-hero'>
            <div className='pillow-hero-image' id='pillowise-logo-panel'>
              <img src={PillowiseLogo} alt="Pillowise" id='pillowise-hero-logo' />
            </div>
            <div className='pillow-hero-text'>
              <h1>Pillowise Custom-Fit Pillows</h1>
              <h3>Finally, a pillow that measures up. Find your perfect pillow size with Pillowise's custom-fit technology, built for optimal neck, joint, and muscle support.</h3>
              <a href='/contact-us'><button>Ask About Availability</button></a>
            </div>
          </div>

          <h1>Your Perfect Fit, In 3 Steps</h1>
          <div className='pillow-steps'>
            {STEPS.map((step, i) => (
              <div className='pillow-step' key={step.title}>
                <span className='pillow-step-number'>{i + 1}</span>
                <h3>{step.title}</h3>
                <h4>{step.text}</h4>
              </div>
            ))}
          </div>

          <h1>Why It Works</h1>
          <ul className='pillow-benefits'>
            {BENEFITS.map((benefit) => (
              <li key={benefit}><h3>{benefit}</h3></li>
            ))}
          </ul>

          <h1>See It Up Close</h1>
          <div className='pillow-gallery'>
            {GALLERY_IMAGES.map(({ label, src }) => (
              <div className={`pillow-gallery-item${src ? ' has-image' : ''}`} key={label}>
                {src ? (
                  <img src={src} alt={label} className='pillow-gallery-img' />
                ) : (
                  <>
                    <AiOutlinePicture id='pillow-placeholder-icon' />
                    <p>{label}</p>
                  </>
                )}
              </div>
            ))}
          </div>

          <h1>How to Purchase</h1>
          <div className='pillow-purchase-options'>
            <div className='pillow-purchase-card'>
              <h3>Available In-Office</h3>
              <h3>Get measured and pick one up at the front desk during your next visit.</h3>
              <a href='/contact-us'><button>Contact Us</button></a>
            </div>
            <div className='pillow-purchase-card'>
              <h3>Ask Dr. Chon</h3>
              <h3>Not sure if it's the right fit? Ask about it at your next appointment or give us a call.</h3>
              <a href='tel:2536309777'>
                <button id='pillow-call-button'><AiFillPhone /> (253) 630-9777</button>
              </a>
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </div>
  )
}
